module.exports = __webpack_public_path__ + "img/gift.60054973.svg";